import { VueEditor } from 'vue2-editor'
import actionsForm from '@/shared/mixins/actionsForm'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import EnterpriseUnityRepository from '@/shared/http/repositories/realestate/enterpriseunity'
import TechnicianRepository from '@/shared/http/repositories/realestate/technician'
import EngineerRepository from '@/shared/http/repositories/realestate/engineer'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import {mask} from 'vue-the-mask'
import { loading, toast } from '@/shared/utils/UIHelper'
import { ptBR } from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import REClientRepository from '@/shared/http/repositories/realestate/client'
import data from './data'

const tabIndex = {
  typeende: 0
}

export default {
  mixins: [actionsForm],
  props:
  {
    dataDetails: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      campoUnidade: '',
      tipo: [],
      patologia: null,
      disabledTecnico: true,
      popupPage: 1,
      ptBR: ptBR,
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      // camposrquired: ['nomemorador', 'celular', 'email', 'celular', 'cpf', 'empreendimentoid', 'empreendimentounidadeid'],
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline'],
        [{ color: [] }]
      ],
      hours: ['8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30'],
      dataAllenterprise: [],
      dataEmpreendimento: [],
      dataAllenterpriseUnity: [],
      datalAlltenico: [],
      datalAllEngenheiro: [],
      dataAllGetPatologia: [],
      cpfobj: [],
      dataallStatusOcorrencia: [],
      dataTenicalHour: [],
      tecnicoObj: {
        type: Object,
        default: {}
      },
      engineerObj: {
        type: Object,
        default: {}
      },
      disableright: false,
      changeMonth: false,
      disableleft: false,
      stepdays: 1,
      months: [
        { name: 'Janeiro', color: '#28a745' },
        { name: 'Fevereiro', color: '#28a745' },
        { name: 'Março', color: '#28a745' },
        { name: 'Abril', color: '#28a745' },
        { name: 'Maio', color: '#28a745' },
        { name: 'Junho', color: '#28a745' },
        { name: 'Julho', color: '#28a745' },
        { name: 'Agosto', color: '#28a745' },
        { name: 'Setembro', color: '#28a745' },
        { name: 'Outubro', color: '#28a745' },
        { name: 'Novembro', color: '#28a745' },
        { name: 'Dezembro', color: '#28a745' }
      ],
      daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      days: [],
      currentMonthIndex: null,
      selectedDate: null,
      daysofweeks: ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sabado'],
      daysofYears: ['JANEIRO', 'FEVEREIRO', 'MARÇO', 'ABRIL', 'MAIO', 'JUNHO', 'JULHO', 'AGOSTO', 'SETEMBRO', 'OUTUBRO', 'NOVEMBRO', 'DEZEMBRO'],
      formnewoccourence: data,
      nometecnico: null,
      validadataSolicitacao: false,
      validaTecnico: false,
      validaHorario: false,
      datatecnicohorario: false,
      DataUpdate: {
        horario: null,
        dataselecionada: null,
        tecnicoId: null
      },
      flDisable: false,
      validaformTecnico: false,
      validaformEngineer: false,
      validaDia: false,
      diaCarousel: null,
      tabIndex: tabIndex.typeende
    }
  },
  name: 'agendatechnical',
  components: {
    VueEditor,
    Datepicker
  },
  watch: {
    'formnewoccourence.dataSolicitacao': function (value) {
      if (this.twoselect === false) {
        this.GetHourWithTennicaid()
      }
      if (value !== null) {
        this.disabledTecnico = false
      }
    },
    'dataDetails.patalogia': function (value) {
      this.iconselector(value)
    },
    'dataDetails.patologiaText': function (value) {
      this.dataDetails.patologiaText = value
    },
    'formnewoccourence.tecnicoid': function (value) {
      this.GetUsuarioSelecionado(value)
    },
    'formnewoccourence.engenheiroid': function (value) {
      this.GetEngenheiroSelecionado(value)
    },
    statusOcorencia (newvalue) {
      this.flDisable = newvalue >= 3 || newvalue < 0
      this.editarAvaliacao = !this.flDisable
    }
  },
  computed: {
    dataFormatada () {
      return moment(this.dataDetails.dataSolicitacao).format('DD/MM/YYYY')
    },
    twoselect: function () {
      if (this.formnewoccourence.dataSolicitacao === null || this.formnewoccourence.tecnicoid === null) {
        return false
      }
      this.stepdays = this.getWeekOfMont(this.formnewoccourence.dataSolicitacao.getDate()) - 1
      return true
    },
    getMonthName () {
      return this.daysofYears[this.formnewoccourence.dataSolicitacao.getMonth()]
    },
    // verificarpatologiaselect () {
    //   alert('teste')
    // },
    getDays () {
      let data = []
      this.hours.forEach((hour) => {
        var tecnicoid = this.formnewoccourence.tecnicoid
        let verify = []
        if (this.dataTenicalHour != null) {
          verify = this.dataTenicalHour.filter((Element) => {
            let format = this.formatHours(Element.hours)
            if (format === hour) {
              let validar = false
              if (Element.reOccurence == null) {
                validar = true
              } else {
                Element.reOccurence.filter((Element) => {
                  if (Element.tecnicoId === tecnicoid) {
                    validar = true
                  }
                })
              }
              return validar
            }
            return false
          })
        }
        let obj = {
          value: hour,
          disabled: verify.length > 0
        }
        data.push(obj)
      })
      return data
    },
    getcarouselDays () {
      let datalast = this.getfinalMonth()
      let adddays = this.stepdays * 7
      let dias = []
      this.disableright = false
      this.disableleft = false
      let sevendays = 7
      let dayStart = this.getStartMonth()
      let secondweeks = 0
      let mesCalenders = this.formnewoccourence.dataSolicitacao.getMonth()
      for (var i = adddays; i < (7 + adddays); i++) {
        if (adddays >= 7 && i === adddays) {
          dayStart.setDate(adddays - dayStart.getDay())
          secondweeks = dayStart.getDate() + 1
        }
        if (datalast.getDate() < secondweeks) continue
        if (dayStart.getDay() !== 0 && i === 0) {
          let diasOld = 0
          for (var olddias = dayStart.getDay(); olddias > 0; olddias--) {
            if (olddias === dayStart.getDay()) {
              let monthactualy = this.getStartMonth()
              monthactualy.setMonth(mesCalenders - 1)
              diasOld = this.getfinalMonthCus(monthactualy).getDate()
            }
            let data = {
              value: (diasOld + 1) - olddias,
              disable: true
            }
            this.disableleft = true
            dias.push(data)
            if ((diasOld - olddias) === diasOld) break
            sevendays = sevendays - 1
            if (sevendays === 0) break
          }
        }
        if (secondweeks !== 0) {
          let data = {
            value: secondweeks,
            disable: false
          }
          if (secondweeks === datalast.getDate()) {
            this.disableright = true
          }
          dias.push(data)
          secondweeks = secondweeks + 1
        } else {
          let data = {
            value: i + 1,
            disable: false
          }
          if ((i + 1) === 1) {
            this.disableleft = true
          }
          if ((i + 1) === datalast.getDate()) {
            this.disableright = true
          }
          dias.push(data)
        }
        sevendays = sevendays - 1
        if (sevendays !== 0 && datalast.getDate() === secondweeks - 1) {
          let totalseven = sevendays
          let daysfal = 1
          while (daysfal <= totalseven) {
            let data = {
              value: daysfal,
              disable: true
            }
            this.disableright = true
            dias.push(data)
            daysfal++
            sevendays = sevendays - 1
          }
        }
        if (sevendays === 0) break
      }
      return dias
    }
  },
  mounted () {
    this.formatahora(this.dataDetails.horarioFormatado)
    this.validatetecnical()
    // this.getHoursTecnico()
    this.getEmpreendimento()
    this.getAllTenico()
    this.getAllEngenheiro()
    // this.GetEmpreendimentoById()
    // this.getallproblamRaiz()
    this.GetPatologia()
    // this.getApartamento()
    this.getVistoriaById(this.dataDetails)
  },
  directives: {mask},
  methods: {
    setdayInitial () {
      /*eslint-disable*/
      let dayinput = document.getElementById('day-' + this.formnewoccourence.dataSolicitacao.getDate())
      if (dayinput === undefined || dayinput === null) return
      dayinput.classList.add('one-day-active')
    },

    GetUsuarioSelecionado (value) {
      if (value != undefined || value != null) {
        TechnicianRepository.GetById(value)
        .then((Response) => {
          this.dataDetails.tecnico = Response.data
          this.dataDetails.tecnicoId = this.dataDetails.tecnico.id
        })
        .catch((Error) => {

        }) 
      }
    },
    GetEngenheiroSelecionado (value) {
      EngineerRepository.GetById(value)
        .then((Response) => {
          this.dataDetails.engenheiro = Response.data
          this.dataDetails.engenheiroid = this.dataDetails.engenheiro.id
        })
        .catch((Error) => {

        })
    },
    GetnameWeek (month) {
      return this.daysofweeks[month].substring(0,3)
    },
    formatadatas(date) {
      let formated =  Intl.DateTimeFormat("pt-br").format(date)
      return formated
    },
    nextstepdays () {
      this.stepdays =  this.stepdays + 1
    },
    downstepdays() {
      this.stepdays = this.stepdays - 1
    },
    popupcurrenceOpen () {
      Object.keys(this.formnewoccourence).forEach((Element) => {
        if(typeof this.formnewoccourence[Element] === 'boolean') this.formnewoccourence[Element] = false
        else this.formnewoccourence[Element] = null
      })
      this.dataTenicalHour = []
      this.$refs['popupcurrence-modal'].show()
    },
    verificarDataSelcionada (data) {
      if (this.formnewoccourence.dataSolicitacao.getDate() === data) return true
      return false
    },
    setMonthDown(){
      this.stepdays = 0
      this.changeMonth = true
      this.formnewoccourence.dataSolicitacao.setMonth(this.formnewoccourence.dataSolicitacao.getMonth() - 1)
      this.formnewoccourence.dataSolicitacao = new Date(this.formnewoccourence.dataSolicitacao)
      this.GetHourWithTennicaid()
    },
    setMonthplus () {
      this.stepdays = 0
      this.changeMonth = true
      this.formnewoccourence.dataSolicitacao.setMonth(this.formnewoccourence.dataSolicitacao.getMonth() + 1)
      this.formnewoccourence.dataSolicitacao = new Date(this.formnewoccourence.dataSolicitacao)
      this.GetHourWithTennicaid()
    },
    selectDay (day) {
        let inputactive  = document.querySelectorAll('.one-day-active')
        let dayid = document.getElementById('day-' + day)
        if(dayid.classList.contains('one-day-disabled')) return
        if(inputactive !== null && inputactive !== undefined) {
          inputactive.forEach((Element) => {
            Element.classList.remove('one-day-active')
          })
        }
        this.resetHour()
        this.formnewoccourence.dataSolicitacao.setDate(day)
        this.formnewoccourence.dataSolicitacao = this.formnewoccourence.dataSolicitacao
        this.dataDetails.dataSolicitacao = this.formnewoccourence.dataSolicitacao
        dayid.classList.add('one-day-active')
        this.DataUpdate.dataselecionada = this.formnewoccourence.dataSolicitacao
        this.GetHourWithTennicaid()

    },
    teste () {
      if (this.disabledTecnico === true) {
        toast.warning('Selecione primeiro uma data')
      }
    },
    changeTecnico () {
        if(this.formnewoccourence.tecnicoid === '') {
          this.dataTenicalHour = []
        }
        if(this.formnewoccourence.tecnicoid != '' && this.formnewoccourence.tecnicoid != null) {
          this.GetUsuarioSelecionado()
        }
        if(this.formnewoccourence.engenheiroid != '' && this.formnewoccourence.engenheiroid != null){
          this.GetHourWithTennicaid()
        }
    },
    changeEngenheiro () {
      if(this.formnewoccourence.engenheiroid === '') {
        this.dataTenicalHour = []
      }
      if(this.formnewoccourence.engenheiroid != '' && this.formnewoccourence.engenheiroid != null) {
        this.GetEngenheiroSelecionado(formnewoccourence.engenheiroid)
      }
      if (this.formnewoccourence.tecnicoid != '' && this.formnewoccourence.tecnicoid != null){
        this.GetHourWithTennicaid()
      }
  },
    GetHourWithTennicaid () {
      this.dataDetails.dataSolicitacao = this.formnewoccourence.dataSolicitacao
        let data = {
          DataChosen: this.dataDetails.dataSolicitacao
        }
        loading.push()
        OcurrenceRepository.GetHourWithTennicaid(this.formnewoccourence.tecnicoid, data)
          .then((Response) => {
            this.dataTenicalHour = Response.data
            loading.pop()
          })
          .catch((Error) => {
            loading.pop()
          })
    },
    getWeek (date) {
      let monthStart = new Date(date);
      monthStart.setDate(0);
      let offset = (monthStart.getDay() + 1) % 7 - 1; // -1 is for a week starting on Monday
      return Math.ceil((date.getDate() + offset) / 7);
    },
    popupcurrenceClose () {
      this.$refs['popupcurrence-modal'].hide()
    },
    getfinalMonthCus (date) {
      let lastdate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      return lastdate
    },
    getfinalMonth () {
      let lastdate = new Date(this.formnewoccourence.dataSolicitacao.getFullYear(), this.formnewoccourence.dataSolicitacao.getMonth() + 1, 0)
      return lastdate
    },
    getStartMonth () {
      let startmonth = new Date(this.formnewoccourence.dataSolicitacao.getFullYear(), this.formnewoccourence.dataSolicitacao.getMonth(), 1)
      return startmonth
    },
    GetPatologia () {
      loading.push()
      OcurrenceRepository.GetPatologia()
        .then((Response) => {
          loading.pop()
          this.dataAllGetPatologia = Response.data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    getAllTenico () {
        TechnicianRepository.GetAll()
        .then((Response) => {
          this.datalAlltenico = Response.data
        })
        .catch((Error) => {

        })
    },
    getAllEngenheiro () {
      EngineerRepository.GetAll()
      .then((Response) => {
        this.datalAllEngenheiro = Response.data
      })
      .catch((Error) => {

      })
  },
    resetHour() {
      this.formnewoccourence.horario = null
      let inputhoursactived = document.querySelectorAll('.hour-active')
      if (inputhoursactived !== null) {
        inputhoursactived.forEach((Element) => {
          Element.classList.remove('hour-active')
        })
      }
    },
    iconselector (e) {
      let patologia = parseInt(e)
      if (patologia === 0) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Infiltracao.svg'
      if (patologia === 1) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Eletrico.svg'
      if (patologia === 2) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Pisos_Revestimento.svg'
      if (patologia === 3) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Esquadrias.svg'
      if (patologia === 4) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Vedacao.svg'
      if (patologia === 5) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Pintura.svg'
      if (patologia === 6) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Loucas.svg'
      if (patologia === 7) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Hidraulica.svg'
      if (patologia === 8) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Tubulacoes.svg'
      if (patologia === 9) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Estrutura.svg'
      if (patologia === 10) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Impermeabilizacao.svg'
      if (patologia === 11) return 'https://static.zopone.com.br/img/realestate/icon/ocurrence/Icon_Outros.svg'
    },
    sethour(hour) {
      console.log(this.dataDetails)
      let outravariavel = hour.replace(":", '.')
    let horareplace = parseFloat(outravariavel)
     let input = document.querySelectorAll('.hour-active')
     let divhour = document.getElementById('hour-' + hour)
     if(divhour.classList.contains('hour-disable')) return
     if(input !== null || input !== undefined) {
       input.forEach((Element) => Element.classList.remove('hour-active'))
     }
     this.formnewoccourence.horario = horareplace
     this.DataUpdate.horario = this.formnewoccourence.horario
     this.dataDetails.horario = this.DataUpdate.horario
     this.dataDetails.horarioFormatado = hour
     this.datatecnicohorario = true
     divhour.classList.add('hour-active')

    },
    verifyFormData () {
      if(this.formnewoccourence.horario != null && this.formnewoccourence.dataSolicitacao != null && (this.formnewoccourence.tecnicoid != null || this.formnewoccourence.tecnicoid != '')) return true
      if(this.formnewoccourence.horario == null) toast.error('Selecione um Horario!!')
      if(this.formnewoccourence.dataSolicitacao == null) toast.error('Selecione uma Data!!')
      if(this.formnewoccourence.tecnicoid == null || this.formnewoccourence.tecnicoid == '' ) toast.error('Selecione um Técnico!!')
      if(this.formnewoccourence.engenheiroid == null || this.formnewoccourence.engenheiroid == '' ) toast.error('Selecione um Engenheiro!!')
      return true
    },
    verifyForm () {
      let error = []
      this.camposrquired.forEach((Element) => {
        if (this.formnewoccourence[Element] === null) error.push(Element)
      })
      if(error.length > 0) {
        error.forEach((Element) => {
          let name = Element
          if(Element === 'nomemorador') name = 'Nome do Morador'
          if(Element === 'empreendimentoid') name = 'Empreendimento'
          if(Element === 'empreendimentounidadeid') name = 'Apartamento'
          toast.error(`O campo ${name} não foi preenchido!!`)
        })

        return false
      }
      if(!this.formnewoccourence.email.includes('@')){
        toast.error(`O campo E-mail esta invalido!!`)
        return false
      }
      return true
    },
    getallproblamRaiz() {
      loading.push()
      OcurrenceRepository.GetStatusOcorrencia()
        .then((Response) => {
          loading.pop()
          this.dataallStatusOcorrencia = Response.data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    formatHours(hour) {
      if (hour != null) {
        if(!hour.toString().includes('.')) {
          return hour.toString() + ":00"
        } else {
          return hour.toString().replace(".", ':') + "0"
        }
      } else {
          return false
      }

    },
    verificarTecnicoAndHour(hour) {
      var tecnicoid = this.formnewoccourence.tecnicoid
      let verify = this.dataTenicalHour.filter((Element) => {
        let format = this.formatHours(Element.hours)
        if(format ==  hour ) {
          let validar = false
          Element.reOccurence.filter((Element) => {
            if(Element.tecnicoId == tecnicoid) validar = true
          })
         return validar > 0 ? true : false
        }
        return false

      })
      if(verify.length > 0) return true
        return false
    },
    getTecnico(id) {
        let tecnico = this.datalAlltenico.find((Element) => Element.id == id)
        if(tecnico == null || tecnico == undefined ) return " - "
        return tecnico.nome
    },
    getEngenheiro(id) {
        let engenheiro = this.datalAllEngenheiro.find((Element) => Element.id == id)
        if(engenheiro == null || engenheiro == undefined ) return " - "
        return engenheiro.nome
    },
    getEmpreendimentoId(id){
      let empreendimento = this.dataAllenterprise.find((Element) => Element.id == id)
      if(empreendimento == null || empreendimento == undefined ) return " - "
      return empreendimento.nome
    },
    getEmpreendimentounidadeid(id){
      let empreendimentounidade = this.dataAllenterpriseUnity.find((Element) => Element.id == id)
      if(empreendimentounidade == null || empreendimentounidade == undefined ) return " - "
      return empreendimentounidade.nomeApartamento
    },
    getEmpreendimento () {
      EnterpriseRepository.GetAll()
        .then((Response) => {
          this.dataAllenterprise = Response.data.data
        })
        .catch((Error) => {

        })
    },
    TipoUnidadeEmpreendimento (data){
      EnterpriseRepository.GetTipoByEmpreendimentoId(data).then((Response) => {
        this.TipoUnidadeEmpreendimentos (Response.data[0].tipo)

      })
      .catch((Error) => {

      })
    },

    TipoUnidadeEmpreendimentos (tipo){
        if (tipo !== null || tipo != undefined) {
          if(tipo == 0) {
            this.campoUnidade = 'Unidade'
            this.getEmpreendimentoUnidade()
          } else if (tipo == 1) {
            this.campoUnidade = 'Lote'
            this.getEmpreendimentoUnidade()
          } else {
            this.campoUnidade = 'Casa'
            this.getEmpreendimentoUnidade()
          }

        }
    },


    GetEmpreendimentoById (e) {
      REClientRepository.GetEmpreendimentoByUnidadeEmpreendimento(e.target.value)
        .then((Response) => {
          this.dataAllenterprise = Response.data
          if (this.dataAllenterprise.length == 1){
            this.formnewoccourence.empreendimentoid = Response.data[0].empreendimentoId
          }
        })
        .catch((Error) => {

        })
    },

    getApartamento () {
      EnterpriseUnityRepository.GetApartamento(this.formnewoccourence.empreendimentoid, this.formnewoccourence.cpf)
        .then((Response) => {
          this.dataAllenterpriseUnity = Response.data
          if (this.dataAllenterpriseUnity.length == 1){
            this.formnewoccourence.empreendimentounidadeid = Response.data[0].empreendimentounidadeid
          }
        })
        .catch((Error) => {

        })
    },
    getEmpreendimentoUnidade () {
      EnterpriseUnityRepository.GetAllByEmpreendimentoId(this.formnewoccourence.empreendimentoid)
        .then((Response) => {
          this.dataAllenterpriseUnity = Response.data.data
        })
        .catch((Error) => {

        })
    },
    verifyproblam() {
      if (this.formnewoccourence.patologia == null) {
        toast.error('Selecione um problema raiz!!')
        return false
      }
      else {
        return true
      }
    },
    verifydescription () {
      if(this.formnewoccourence.descricao == null || this.formnewoccourence.descricao == '') {
        toast.error("É obrigatorio o preenchimento do campo observação!!!")
        return false
      }
      return true
    },
    setvalueProblem(value) {
      this.formnewoccourence.patologia  = value
      let divs = document.querySelectorAll('.divchamado-actived')
      if(divs != null && divs != undefined) {
        divs.forEach((Element) => {
          Element.classList.remove('divchamado-actived')
        })
      }
      document.getElementById('panel-chamado-' + value).classList.add('divchamado-actived')
    },

    nextSlide: function() {
      this.currentSlide++;
      if (this.currentSlide >= this.months.length) {
        this.currentSlide = 0;
      }
    },
    prevSlide: function() {
      this.currentSlide--;
      if (this.currentSlide < 0) {
        this.currentSlide = this.months.length - 1;
      }
    },
    isToday(day) {
      const today = moment();
      return day.date === today.date() && day.month === today.month() && day.year === today.year();
    },
    isSelected(day) {
      return day.date === (this.selectedDate ? this.selectedDate.date : null) && day.month === (this.selectedDate ? this.selectedDate.month : null) && day.year === (this.selectedDate ? this.selectedDate.year : null);
    },
    selectDate(day) {
      if (day.month === this.currentMonthIndex) {
        this.selectedDate = {
          date: day.date,
          month: day.month,
          year: day.year
        }
      }
    },
    getHoursTecnico() {
      loading.push()
        this.dataDetails.dataSolicitacao = this.DataUpdate.dataselecionada
        let data = {
          DataChosen: this.dataDetails.dataSolicitacao
        }
        OcurrenceRepository.GetTecnicoAndHours(data)
        .then((Response) => {
          this.dataTenicalHour = Response.data
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    inserir () {
      loading.push()
      if (this.formnewoccourence.horario != null) {
        this.formnewoccourence.horario = parseFloat(this.formnewoccourence.horario.replace(':', '.'))
      }
      OcurrenceRepository.Inserir(this.formnewoccourence)
        .then((Response) => {
          if(Response.data) {
            this.popupcurrenceClose()
            toast.success("Ocorrencia salva com sucesso!!")
            this.$emit('reload')
          } else {
            toast.error("Não foi possivel salvar a ocorrencia!!")
          }
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
          toast.error("Não foi possivel salvar a ocorrencia!!")
        })
    },
    showModal () {
      this.$refs['my-modal'].show()
      this.$bvModal.hide('popuptecnico-modal')
      this.getTecnico()
      this.getEngenheiro()
    },
    closeModal () {
      this.$refs['popupcurrence-modal'].hide()
    },
    openPopupTecnico () {
      this.$refs['popuptecnico-modal'].show()
      this.getTecnico()
    },
    back () {
      this.$refs['my-modal'].hide()
      this.openPopupTecnico()
    },
    getVistoriaById (e) {
      let id = e.id
      OcurrenceRepository.GetVistoriaById(id)
        .then((res) => {
          // this.dataDetails = res.data
          // this.patologia =  res.data.patalogia
        })
        .catch(() => {})
    },
    tecnicoform () {
        if ((this.tecnicoObj.nome != null || this.tecnicoObj.nome != undefined) 
          && (this.tecnicoObj.telefone != null || this.tecnicoObj.telefone != undefined) 
          && (this.tecnicoObj.cpf != null || this.tecnicoObj.cpf != undefined) 
          && (this.tecnicoObj.dataNascimento != null || this.tecnicoObj.dataNascimento != undefined) 
          && (this.tecnicoObj.email != null || this.tecnicoObj.email != undefined)) {
          if (!this.tecnicoObj.email.includes('@')) {
            toast.error(`O campo E-mail esta invalido!!`)
          }
          else {
            this.validaformTecnico = true
          }
        } else {
          this.validaformTecnico = false
          if (this.tecnicoObj.nome == null || this.tecnicoObj.nome == undefined) {
            toast.warning('Nome deve ser preenchido!!')
          }
          if (this.tecnicoObj.telefone == null || this.tecnicoObj.telefone == undefined) {
            toast.warning('Telefone deve ser preenchido!!')
          }
          if (this.tecnicoObj.cpf == null || this.tecnicoObj.cpf == undefined) {
            toast.warning('Cpf deve ser preenchido!!')
          }
          if (this.tecnicoObj.dataNascimento == null || this.tecnicoObj.dataNascimento == undefined) {
            toast.warning('Data de Nascimento deve ser preenchido!!')
          }
          if (this.tecnicoObj.email == null || this.tecnicoObj.email == undefined) {
            toast.warning('E-mail deve ser preenchido!!')
          }
      }
      
    },
    engineerform () {
      if ((this.engineerObj.nome != null || this.engineerObj.nome != undefined) 
        && (this.engineerObj.telefone != null || this.engineerObj.telefone != undefined) 
        && (this.engineerObj.cpf != null || this.engineerObj.cpf != undefined) 
        && (this.engineerObj.dataNascimento != null || this.engineerObj.dataNascimento != undefined) 
        && (this.engineerObj.email != null || this.engineerObj.email != undefined)) {
        if (!this.engineerObj.email.includes('@')) {
          toast.error(`O campo E-mail esta invalido!!`)
        }
        else {
          this.validaformEngineer = true
        }
      } else {
        this.validaformEngineer = false
        if (this.engineerObj.nome == null || this.engineerObj.nome == undefined) {
          toast.warning('Nome deve ser preenchido!!')
        }
        if (this.engineerObj.telefone == null || this.engineerObj.telefone == undefined) {
          toast.warning('Telefone deve ser preenchido!!')
        }
        if (this.engineerObj.cpf == null || this.engineerObj.cpf == undefined) {
          toast.warning('Cpf deve ser preenchido!!')
        }
        if (this.engineerObj.dataNascimento == null || this.engineerObj.dataNascimento == undefined) {
          toast.warning('Data de Nascimento deve ser preenchido!!')
        }
        if (this.engineerObj.email == null || this.engineerObj.email == undefined) {
          toast.warning('E-mail deve ser preenchido!!')
        }
    }
    
  },
    addTecnico () {
      loading.push()
      this.tecnicoform()
      if(this.validaformTecnico == true) {
        TechnicianRepository.Post(this.tecnicoObj)
          .then((Response) => {
             loading.pop()
            if (Response.data) {
              this.getAllTenico()
              toast.success('Técnico inserido com sucesso!')
            } else {
              toast.error('Não foi possivel salvar um técnico!')
            }
            this.back()
          })
          .catch((Error) => {
            loading.pop()
            console.error(Error)
          })
      } else {
        loading.pop()
      }
    },
    addEngenheiro () {
      loading.push()
      this.engineerform()
      if(this.validaformEngineer == true) {
        EngineerRepository.Post(this.engineerObj)
          .then((Response) => {
             loading.pop()
            if (Response.data) {
              this.getAllEngenheiro()
              toast.success('Engenheiro inserido com sucesso!')
            } else {
              toast.error('Não foi possivel salvar um técnico!')
            }
            this.back()
          })
          .catch((Error) => {
            loading.pop()
            console.error(Error)
          })
      } else {
        loading.pop()
      }
    },
    getWeekOfMont (day) {
      this.diaCarousel = day
      /*eslint-disable*/
      let week = 0
      let datalast = this.getfinalMonth()
      var WeekWhile = true
      let dias = []
      this.disableright = false
      this.disableleft = false
      let sevendays = 7
      let secondweeks = 0
      let mesCalenders = this.formnewoccourence.dataSolicitacao.getMonth()
      while (WeekWhile) {
        dias = []
        let dayStart = this.getStartMonth()
        let adddays = week * 7
        week = week + 1
        for (var i = adddays; i < (7 + adddays); i++) {
          if (adddays >= 7 && i === adddays) {
            dayStart.setDate(adddays - dayStart.getDay())
            secondweeks = dayStart.getDate() + 1
          }
          if (datalast.getDate() < secondweeks) continue
          if (dayStart.getDay() !== 0 && i === 0) {
            let diasOld = 0
            for (var olddias = dayStart.getDay(); olddias > 0; olddias--) {
              if (olddias === dayStart.getDay()) {
                let monthactualy = this.getStartMonth()
                monthactualy.setMonth(mesCalenders - 1)
                diasOld = this.getfinalMonthCus(monthactualy).getDate()
              }
              let data = {
                value: (diasOld + 1) - olddias,
                disable: true
              }
              this.disableleft = true
              dias.push(data)
              if ((diasOld - olddias) === diasOld) break
              sevendays = sevendays - 1
              if (sevendays === 0) break
            }
          }
          if (secondweeks !== 0) {
            let data = {
              value: secondweeks,
              disable: false
            }
            if (secondweeks === datalast.getDate()) {
              this.disableright = true
            }
            dias.push(data)
            secondweeks = secondweeks + 1
          } else {
            let data = {
              value: i + 1,
              disable: false
            }
            if ((i + 1) === 1) {
              this.disableleft = true
            }
            if ((i + 1) === datalast.getDate()) {
              this.disableright = true
            }
            dias.push(data)
          }
          sevendays = sevendays - 1
          if (sevendays !== 0 && datalast.getDate() === secondweeks - 1) {
            let totalseven = sevendays
            let daysfal = 1
            while (daysfal <= totalseven) {
              let data = {
                value: daysfal,
                disable: true
              }
              this.disableright = true
              dias.push(data)
              daysfal++
              sevendays = sevendays - 1
            }
          }
          if (sevendays === 0) break
        }
        let verificar = dias.filter((Element) => Element.value === day)
        if (verificar.length > 0) break
      }
      return week
    },
    validatetecnical () {
        if (this.dataDetails.dataSolicitacao != null) {
          this.validadataSolicitacao = true
        }
        if (this.dataDetails.tecnicoId != null) {
          this.validaTecnico = true
        }
        if (this.dataDetails.horario != null) {
          this.validaHorario = true
        }
        if (this.validadataSolicitacao === true && this.validaTecnico === true && this.validaHorario === true) {
          this.datatecnicohorario = true
          this.dataDetails.validate = true
        }
    },
    editadatahoratecnico () {
      this.datatecnicohorario = false
      this.validadataSolicitacao = false
      this.validaTecnico = false
      this.disabledTecnico = false
      this.validaHorario = false
      this.datatecnicohorario = false
      // this.dataDetails.dataSolicitacao = null
      // this.dataDetails.horario = null
      // this.dataDetails.tecnicoId = null
      this.dataDetails.validate = false
    },
    formatahora (hour) {
      if (hour.includes(',')) {
        let novoformato = hour.replace(',',':')
        this.dataDetails.horarioFormatado = novoformato
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/technicalvisit/agendatechnical/agendatechnical.js